<div class="base-container">
  <nav class="navbar">
    <div class="container">
      <div class="flex flex-space-between">
        <div class="flex">
          <h1 class="is-size-3 has-text-weight-semibold">IdP Data Aggregation</h1>
        </div>
      </div>
    </div>
  </nav>

  <div class="container" style="background: #fff">
    <div class="main-layout">
      <section class="main-content text-center">
        Du har loggat ut från IdP Data Aggregation<br />
        <a tabindex="0" (click)="redirect()" (keydown.enter)="redirect()">Återgå till Administration</a>
      </section>
    </div>
  </div>
</div>
